<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="numericId > 0">Schooljaar bewerken</span>
				<span class="pl-2" v-else>Nieuw schooljaar</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-alert v-if="formError" type="error" dense outlined class="mb-4">{{ formError }}</v-alert>
			<v-form ref="form" v-model="formValid">
				<v-row>
					<v-col cols="12" sm="6">
						<v-text-field
							dense
							filled
							v-model.number="form.id"
							label="ID *"
							type="number"
							:disabled="numericId > 0"
							:rules="[rules.requiredId]"
							hint="Uniek nummer; wordt niet automatisch gegenereerd."
							persistent-hint
						></v-text-field>
						<v-text-field
							dense
							filled
							v-model="form.name"
							label="Naam *"
							:rules="[rules.required]"
							hint="Bijv. 2026-2027"
							persistent-hint
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-checkbox
							v-model="form.active"
							:true-value="1"
							:false-value="0"
							label="Actief (regulier)"
						></v-checkbox>
						<v-checkbox
							v-model="form.active_cursus"
							:true-value="1"
							:false-value="0"
							label="Actief cursus"
						></v-checkbox>
						<v-checkbox
							v-model="form.active_finance"
							:true-value="1"
							:false-value="0"
							label="Actief finance"
						></v-checkbox>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" depressed :loading="saving" @click="submit">Opslaan</v-btn>
			<v-btn color="dark" depressed @click="$router.go(-1)">Annuleren</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "SchoolyearAddEdit",
	props: ["id"],
	data() {
		return {
			formValid: false,
			saving: false,
			formError: "",
			form: {
				id: null,
				name: "",
				active: 0,
				active_cursus: 0,
				active_finance: 0
			},
			rules: {
				required: function(v) {
					return (v != null && String(v).trim() !== "") || "Verplicht veld";
				},
				requiredId: function(v) {
					return (v != null && v !== "" && Number(v) > 0) || "Vul een geldig ID in";
				}
			}
		};
	},
	computed: {
		numericId() {
			var n = parseInt(this.id, 10);
			return isNaN(n) ? 0 : n;
		}
	},
	created() {
		if (this.numericId > 0) {
			this.fetchSchoolyear();
		} else {
			this.suggestNextId();
		}
	},
	methods: {
		suggestNextId() {
			var self = this;
			ax.get("/schoolyear/manage_all")
				.then(function(res) {
					var rows = Array.isArray(res.data) ? res.data : [];
					var maxId = 0;
					for (var i = 0; i < rows.length; i++) {
						var rid = Number(rows[i].id) || 0;
						if (rid > maxId) maxId = rid;
					}
					self.form.id = maxId + 1;
				})
				.catch(function() {
					self.form.id = null;
				});
		},
		fetchSchoolyear() {
			var self = this;
			ax.get("/schoolyear/single/" + this.numericId)
				.then(function(res) {
					var row = res.data;
					if (!row || !row.id) {
						self.formError = "Schooljaar niet gevonden.";
						return;
					}
					self.form.id = row.id;
					self.form.name = row.name || "";
					self.form.active = Number(row.active) === 1 ? 1 : 0;
					self.form.active_cursus = Number(row.active_cursus) === 1 ? 1 : 0;
					self.form.active_finance = Number(row.active_finance) === 1 ? 1 : 0;
				})
				.catch(function() {
					self.formError = "Schooljaar kon niet worden geladen.";
				});
		},
		submit() {
			var self = this;
			this.formError = "";
			if (this.$refs.form && !this.$refs.form.validate()) {
				return;
			}
			this.saving = true;
			var payload = {
				id: Number(this.form.id),
				name: this.form.name,
				active: Number(this.form.active) === 1 ? 1 : 0,
				active_cursus: Number(this.form.active_cursus) === 1 ? 1 : 0,
				active_finance: Number(this.form.active_finance) === 1 ? 1 : 0
			};
			if (this.numericId > 0) {
				ax.post("/schoolyear/update/" + this.numericId, payload)
					.then(function() {
						self.$router.push({ path: "/schooladmin/schoolyear" });
					})
					.catch(function(err) {
						var msg =
							(err.response && err.response.data && err.response.data.msg) ||
							"Opslaan is mislukt.";
						self.formError = msg;
					})
					.finally(function() {
						self.saving = false;
					});
			} else {
				ax.post("/schoolyear/create", payload)
					.then(function() {
						self.$router.push({ path: "/schooladmin/schoolyear" });
					})
					.catch(function(err) {
						var msg =
							(err.response && err.response.data && err.response.data.msg) ||
							"Aanmaken is mislukt (bestaat het ID al?).";
						self.formError = msg;
					})
					.finally(function() {
						self.saving = false;
					});
			}
		}
	}
};
</script>
